import { legacyColors } from '~/legacyTheme';

export const INFO_BOX_HEIGHT_PX = 200;

export const useSxStyles = () => {
  return {
    infoBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: 'auto',
      width: '300px',
      borderBottom: 0,
      marginRight: '10px',
    },
    infoBoxNoMargin: {
      margin: 0,
    },
    infoBoxBtn: {
      display: 'flex',
      padding: '6px',
      paddingBottom: '7px',
      paddingTop: '7px',
      boxShadow: '1px -1px 5px rgb(0 0 0 / 18%)',
      minHeight: '50px',
      zIndex: 3,
      backgroundColor: legacyColors.white,
    },
    infoBoxBtnShadowLeft: {
      boxShadow: '-1px -1px 18px rgb(0 0 0 / 18%)',
    },
    infoExpansionBox: {
      boxShadow: '1px -1px 5px rgb(0 0 0 / 18%)',
      bottom: '50px',
      width: '300px',
      borderBottom: 0,
      borderRadius: '8px 8px 0 0',
      backgroundColor: legacyColors.white,
    },
    infoExpansionBoxHeader: {
      color: '#f8f8f8',
      background:
        'linear-gradient(to right, #05A4D8 0%, #00ace6 50%,#05A4D8 100%)',
      position: 'relative',
      fontWeight: 'bold',
      fontSize: '14px',
      width: '100%',
      borderRadius: '5px 5px 0 0',
      padding: '6px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    infoExpansionBoxHeaderIcon: {
      cursor: 'pointer',
      fontSize: '16px',
      lineHeight: 1,
      paddingRight: '8px',
      color: '#025874',
      marginRight: '3px',
    },
    infoExpansionBoxHeaderIconPin: { marginLeft: 'auto' },
    infoExpansionBoxContent: {
      height: 'calc(100% - 29px)',
      overflow: 'hidden',
      fontSize: '14px',
    },
    infoExpansionBoxHover: {
      '&:hover': {
        color: legacyColors.white,
      },
    },
    infoExpansionBoxPinned: {
      color: legacyColors.white,
    },
  };
};
